
import { Component, Vue, Ref } from 'vue-property-decorator'
import Publish from './components/publish.vue'
import { ClueService } from '@/services/index'

@Component({
    components: {
        Publish
    }
})
export default class ClueDetail extends Vue {
    private clueSortList = []
    private isLoading = false
    private loadingText = ''
    private clue: any
    @Ref('publish') private publishRef!: any

    private mounted() {
        this.getClueTypeList()
    }

    private async getClueTypeList() {
        this.isLoading = true
        const result = await ClueService.getClueSortList()
        this.isLoading = false
        if (result.status === 200) {
            this.clueSortList = result.data
        }
    }

    private async createClue() {
        const region = this.clue.region
        let [province, city, district] = ['', '', '']
        if (region) {
            [province, city, district] = region.split(',')
        }
        const params = {
            ...this.clue,
            province,
            city,
            area: district
        }
        Reflect.deleteProperty(params, 'region')
        this.isLoading = true
        this.loadingText = '发布中'
        const result = await ClueService.createClue(params)
        this.isLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '发布线索成功'
            })
            return true
        }
        return false
    }

    private onSave() {
        this.publishRef.validate(async (isValid: boolean) => {
            if (isValid) {
                this.clue = this.publishRef.getClue('clue_create')
                this.isLoading = true
                this.loadingText = '上传图片中'
                this.clue.images = await this.publishRef.uploadImg()
                
                // 上传线索
                this.isLoading = true
                this.loadingText = '发布线索中'
                const result = await this.createClue()
                this.isLoading = false
                result && this.publishRef.reset()
            }
        })
    }
}
